import { render, staticRenderFns } from "./HericaClientInfoForm.vue?vue&type=template&id=3e0fee9f&lang=pug"
import script from "./HericaClientInfoForm.vue?vue&type=script&lang=js"
export * from "./HericaClientInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0fee9f')) {
      api.createRecord('3e0fee9f', component.options)
    } else {
      api.reload('3e0fee9f', component.options)
    }
    module.hot.accept("./HericaClientInfoForm.vue?vue&type=template&id=3e0fee9f&lang=pug", function () {
      api.rerender('3e0fee9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/admin-controls/herica-clients/info/HericaClientInfoForm.vue"
export default component.exports